import * as React from 'react';

import Missing140 from './Missing140';

export const missing140 = () => <Missing140 />;

export default {
    title: 'Illustration/Missing140',
    component: Missing140,
    parameters: {
        notes: "`import Missing140 from 'box-ui-elements/es/illustration/Missing140';`",
    },
};
